"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saveV1;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

var _deprecated = require("../deprecated");

var _constants = require("./constants");

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
function saveV1(_ref) {
  let {
    attributes
  } = _ref;
  const {
    images,
    columns = (0, _deprecated.defaultColumnsNumberV1)(attributes),
    imageCrop,
    caption,
    linkTo
  } = attributes;
  const className = `columns-${columns} ${imageCrop ? 'is-cropped' : ''}`;
  return (0, _element.createElement)("figure", _blockEditor.useBlockProps.save({
    className
  }), (0, _element.createElement)("ul", {
    className: "blocks-gallery-grid"
  }, images.map(image => {
    let href;

    switch (linkTo) {
      case _constants.LINK_DESTINATION_MEDIA:
        href = image.fullUrl || image.url;
        break;

      case _constants.LINK_DESTINATION_ATTACHMENT:
        href = image.link;
        break;
    }

    const img = (0, _element.createElement)("img", {
      src: image.url,
      alt: image.alt,
      "data-id": image.id,
      "data-full-url": image.fullUrl,
      "data-link": image.link,
      className: image.id ? `wp-image-${image.id}` : null
    });
    return (0, _element.createElement)("li", {
      key: image.id || image.url,
      className: "blocks-gallery-item"
    }, (0, _element.createElement)("figure", null, href ? (0, _element.createElement)("a", {
      href: href
    }, img) : img, !_blockEditor.RichText.isEmpty(image.caption) && (0, _element.createElement)(_blockEditor.RichText.Content, {
      tagName: "figcaption",
      className: "blocks-gallery-item__caption",
      value: image.caption
    })));
  })), !_blockEditor.RichText.isEmpty(caption) && (0, _element.createElement)(_blockEditor.RichText.Content, {
    tagName: "figcaption",
    className: "blocks-gallery-caption",
    value: caption
  }));
}
//# sourceMappingURL=save.js.map